import React, { ReactElement } from 'react';
import type { Route } from 'next';
import classNames from 'classnames/bind';
import Breadcrumbs from 'components/Breadcrumbs';
import styles from 'sections/Resources/components/SectionHeader/SectionHeader.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = (): ReactElement => {
  return (
    <section className={cn('header')}>
      <img
        className={cn('header__bg-image', 'left')}
        src="/images/pages/Resources/planet-left.webp"
        alt="globe"
      />
      <img
        className={cn('header__bg-image', 'right')}
        src="/images/pages/Resources/planet-right.webp"
        alt="globe"
      />
      <div className={cn('container')}>
        <Breadcrumbs mTop={64} mode="light" links={[{ title: 'Resources', href: '' as Route }]} />
        <div className={cn('header__heading-box')}>
          <h1 className={cn('header__heading')}>
            <span>Freight Forwarding Resources:</span>
            <span>Guides & Insights | DF Alliance</span>
          </h1>
          <p className={cn('header__heading-description')}>
            Explore DF Alliance’s freight forwarding resources, including guides,
            a dictionary, and industry insights to support logistics and supply chain
            professionals
          </p>
        </div>
      </div>
    </section>
  );
};

export default SectionHeader;